var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"elevate-on-scroll":"","app":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleNav}}),_c('v-spacer'),_c('v-btn',{staticClass:"mr-4",on:{"click":_vm.showSync}},[_vm._v(" Sync ")]),_c('HeaderSearch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }